<script>
export default {
  data() {
    return {
      loadedProductList: false,
      productSearchList: [ ],
      p_page: 1,
      p_limit: 20,
      p_count: 0,
      cur_keyword: '',
      product_class_name: '',
      is_get: false, // 是否已获取
    }
  },
  methods: {
    async searchProduct(query) {
      let params = {
        keyword: query,
        page: this.p_page,
        page_size: this.p_limit,
      };
      try {
        const { status, data } = await this.$http.post('product/list', params)
        if (status === 200) {
          this.loadedProductList = true
          this.is_get = true;
          const list = data.data.rows
          this.productSearchList = this.productSearchList.concat(list);
          this.p_count = data.data.count;
        }
      } catch (e) {
      }
    },
    loadMoreProduct() {
      const maxPage = Math.ceil(this.p_count / this.p_limit);
      if (maxPage > this.p_page) {
        this.p_page ++;
        this.searchProduct(this.cur_keyword);
      }
    },
    selectFocus(e) {
      if (e) {
        this.initProductKeyword('');
      }
    },
    initProductKeyword(keyword) {
      if (keyword === this.cur_keyword && this.is_get) {
        return;
      }
      this.cur_keyword = keyword;
      this.p_page = 1;
      this.productSearchList = [];
      this.searchProduct(keyword);
    },
    productSet(item) {
      console.log(item)
      const params = {
        caption: item.product_model,
        id: item.product_id,
      }
      this.productSearchList = [params];
      this.loadedProductList = true;
    },
    changeProductVal(e) {
      // const k = this.productSearchList.find((t) => t.product_model === e);
      // if (k) {
      //   this.product_class_name = k
      // }
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/mixins/productSelect.vue